export default "__VITE_ASSET__663dc893__"